import React, { useState } from "react";
import { Formik, Field } from "formik";
import { Form, Button } from "react-bootstrap";
import { get, isEmpty, isNull } from "lodash";
import { Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/pro-light-svg-icons";
import {
  FieldInput,
  SearchableList,
  FieldDropSide,
  SliderPanel,
  FieldButtonGroup,
  AddToolTip,
} from "../../../components";
const initialValues = {};

const dataTypes = [
  {
    label: "string",
    value: 1,
  },
  {
    value: 2,
    label: "number",
  },
  {
    value: 3,
    label: "date",
  },
];

const fields = {
  Operations: "Operation",
  CustomOperations: "CustomOperations",
};
export const CustomAggregateFunction = (props) => {
  const {
    CAFSlider,
    onCancel,
    setFields,
    setCAFSlider,
    Fields,
    selectedItem,
  } = props;
  const customFields = ["Min", "Max", "Avg", "Sum"];
  const [CurrentField, setCurrentField] = useState(Fields[selectedItem]);
  const [isCustomField, setIsCustomField] = useState(false);
  const toOptionValuesFromMapper = (obj) => {
    return obj.map((elem) => ({
      label: elem,
      value: elem,
    }));
  };

  const toGetOptions = (elem) => {
    if (Fields[elem].type == 1) {
      return [["First", "Last"], []];
    } else if (Fields[elem].type == 2) {
      return [
        ["First", "Last", "Custom"],
        ["Min", "Max", "Avg", "Sum"],
      ];
    } else if (Fields[elem].type == 4) {
      return [
        ["First", "Last", "Custom"],
        ["DateMin", "DateMax"],
      ];
    } else {
      return [[], []];
    }
  };

  const cardDisplay = (item) => {
    return (
      <Card className="category-selection-cardSolo mt-4">
        <div className="category-selection-titleField">
          {item.fieldName[0] == "/" ? (
            <AddToolTip name={item.fieldName.substring(1)} />
          ) : (
            <AddToolTip name={item.fieldName} />
          )}
        </div>
        {/* <div className="category-selection-icon">
          <FontAwesomeIcon icon={faCog} />
        </div> */}
        <div
          className="category-selection-cardType"
          style={{ overflow: "visible" }}
        >
          {item.dataType}
        </div>
        <div className="category-selection-exampleData">
          <AddToolTip name={item.datum} />
          {/* The variable to be substituted with the example data obtained from backend */}
        </div>
        <div className="category-selection-category">
          {item.operation?.trim() != "" ? item.operation : "not found"}
          {/* Aggregate Category to be displayed over here */}
        </div>
      </Card>
    );
  };

  return (
    <SliderPanel
      isOpen={CAFSlider}
      size="45"
      onClose={() => onCancel()}
      showCancel={false}
    >
      <Formik
        initialValues={{
          ...initialValues,
        }}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={() => {
          let temp = [...Fields];
          temp[selectedItem] = CurrentField;
          props.setFieldValue("aggregationOperationEntities", temp);
          setCAFSlider(false);
        }}
      >
        {(formProps) => {
          const {
            handleChange,
            setFieldValue,
            handleSubmit,
            setValues,
            setTouched,
            values,
            setSubmitting,
            ...rest
          } = formProps;
          return (
            <Form
              onSubmit={handleSubmit}
              autoComplete="off"
              className="h-100 my-2"
            >
              <div className="inside-content">
                <div className="d-flex justify-content-between align-baseline">
                  <div>
                    <p className="investment-heading">
                      Configure Aggregate Function
                    </p>
                  </div>
                  <div>
                    <Button variant="secondary" onClick={() => onCancel()}>
                      Cancel
                    </Button>
                    <Button variant="primary" className="ml-4" type="submit">
                      Save
                    </Button>
                  </div>
                </div>
                <div className="break-bar"></div>
                {cardDisplay(CurrentField)}
                <Field
                  isRequired
                  name={fields.Operations}
                  label={"Operations"}
                  placeholder="Operations"
                  options={toOptionValuesFromMapper(
                    toGetOptions(selectedItem)[0]
                  )}
                  selectedValue={
                    customFields.some((item) =>
                      CurrentField.operation?.includes(item)
                    ) || isNull(CurrentField.operation)
                      ? "Custom"
                      : CurrentField.operation
                  }
                  // value={}
                  type="text"
                  autoComplete="off"
                  // value={values[fields.category]}
                  onChange={(value) => {
                    // Fields[selectedItem].operation=value
                    if (value == "Custom") {
                      setIsCustomField(true);
                      setCurrentField({ ...CurrentField, operation: null });
                    } else {
                      setIsCustomField(false);
                      setCurrentField({ ...CurrentField, operation: value });
                    }
                  }}
                  component={FieldButtonGroup}
                />
                {(isCustomField ||
                  customFields.some((item) =>
                    CurrentField.operation?.includes(item)
                  ) ||
                  isNull(CurrentField.operation)) && (
                  <Field
                    isRequired
                    name={fields.CustomOperations}
                    label={"Custom"}
                    placeholder="Custom"
                    options={toOptionValuesFromMapper(
                      toGetOptions(selectedItem)[1]
                    )}
                    selectedValue={CurrentField.operation}
                    type="text"
                    autoComplete="off"
                    value={CurrentField.operation}
                    onChange={(value) => {
                      // Fields[selectedItem].operation=Fields[selectedItem].operation+'-'+value
                      let temp = { ...CurrentField };
                      temp.operation = value;
                      setCurrentField(temp);
                    }}
                    validate={() =>
                      ["", null, undefined].includes(CurrentField.operation)
                        ? "Required"
                        : undefined
                    }
                    component={FieldButtonGroup}
                  />
                )}
              </div>
            </Form>
          );
        }}
      </Formik>
    </SliderPanel>
  );
};
